import FetchSettings from "../../../interfaces/FetchSettings";
import { UserJsonPage } from "../../../interfaces/JsonPage";
import {
  VanillaApiBadge,
  VanillaApiCurrentUser,
  VanillaApiRank,
  VanillaApiRole,
  VanillaApiUser,
} from "../../../interfaces/VanillaApi";
import { getMode } from "../../../utilities";
import VanillaProvider from "./VanillaProvider";

export default class VanillaUsersProvider extends VanillaProvider {
  protected communityUrl = process.env.VANILLA_COMMUNITY_URL;

  public async getCurrentUser(): Promise<VanillaApiCurrentUser> {
    const apiUrl = new URL(this.baseUrl + "users/me");
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const data: VanillaApiCurrentUser = await this.request(
      url.toString(),
      settings
    );
    return data;
  }

  async getCurrentUserFromJsonPage(): Promise<UserJsonPage> {
    try {
      const currentUser = await this.getCurrentUser();
      if (currentUser?.name) {
        const settings: FetchSettings = {
          method: "GET",
        };
        const jsonUserProfile: UserJsonPage = await this.request(
          this.communityUrl +
            "profile/discussions/" +
            currentUser.name +
            ".json",
          settings
        );
        return jsonUserProfile;
      } else {
        return null;
      }
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  public async getUsersByName(keyword: string): Promise<Array<VanillaApiUser>> {
    const apiUrl = this.baseUrl + "users/by-names?name=" + keyword;
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const users: Array<VanillaApiUser> = await this.request(
      url.toString(),
      settings
    );
    return users;
  }

  public async getUserById(id: number): Promise<VanillaApiUser> {
    const apiUrl = this.baseUrl + "users/" + id + "?expand=rank";
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const user: VanillaApiUser = await this.request(url.toString(), settings);
    return user;
  }

  public async getUserBadges(userId: number): Promise<Array<VanillaApiBadge>> {
    const apiUrl = this.baseUrl + "users/" + userId + "/badges";
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const badges: Array<VanillaApiBadge> = await this.request(
      url.toString(),
      settings
    );
    return badges;
  }

  public async getUserRoles(): Promise<Array<VanillaApiRole>> {
    const apiUrl = this.baseUrl + "roles";
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const roles: VanillaApiRole[] = await this.request(
      url.toString(),
      settings
    );
    return roles;
  }

  public async getUserRanks(): Promise<Array<VanillaApiRank>> {
    const apiUrl = this.baseUrl + "ranks";
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const ranks: VanillaApiRank[] = await this.request(
      url.toString(),
      settings
    );
    return ranks;
  }
}
